import { render } from "./MenuSecction.vue?vue&type=template&id=7f25b940"
import script from "./MenuSecction.vue?vue&type=script&lang=js"
export * from "./MenuSecction.vue?vue&type=script&lang=js"

import "./MenuSecction.vue?vue&type=style&index=0&id=7f25b940&scope=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__